/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Injectable } from '@angular/core';
/**
 * Error state matcher that matches when a control is invalid and dirty.
 */
export class ShowOnDirtyErrorStateMatcher {
    /**
     * @param {?} control
     * @param {?} form
     * @return {?}
     */
    isErrorState(control, form) {
        return !!(control && control.invalid && (control.dirty || (form && form.submitted)));
    }
}
ShowOnDirtyErrorStateMatcher.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ShowOnDirtyErrorStateMatcher.ctorParameters = () => [];
function ShowOnDirtyErrorStateMatcher_tsickle_Closure_declarations() {
    /** @type {?} */
    ShowOnDirtyErrorStateMatcher.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    ShowOnDirtyErrorStateMatcher.ctorParameters;
}
/**
 * Provider that defines how form controls behave with regards to displaying error messages.
 */
export class ErrorStateMatcher {
    /**
     * @param {?} control
     * @param {?} form
     * @return {?}
     */
    isErrorState(control, form) {
        return !!(control && control.invalid && (control.touched || (form && form.submitted)));
    }
}
ErrorStateMatcher.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ErrorStateMatcher.ctorParameters = () => [];
function ErrorStateMatcher_tsickle_Closure_declarations() {
    /** @type {?} */
    ErrorStateMatcher.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    ErrorStateMatcher.ctorParameters;
}
//# sourceMappingURL=error-options.js.map